import {Box, Typography} from '@mui/material';
import {useEffect, useMemo} from 'react';
import LayerAccordionItem from './LayerAccordionItem.tsx';
import {useGetCollectionLayers} from '@src/api/configurations';
import ErrorMessage from '@src/components/common/ErrorMessage.tsx';
import LoadingMessage from '@src/components/common/LoadingMessage.tsx';
import useVisualizationParams from '@src/hooks/useVisualizationParams';
import dimensions from '@src/styles/dimensions.ts';

export const LayerSelection = () => {
  const {configurationId, collectionId, layerId, setLayerId} =
    useVisualizationParams();

  const {
    layers,
    isLoading,
    error: layersError,
  } = useGetCollectionLayers(configurationId, collectionId);

  const error = useMemo(() => {
    if (!configurationId) {
      return {message: 'You must select configuration'};
    }
    if (!collectionId) {
      return {message: 'You must select collection'};
    }
    return layersError;
  }, [layersError, configurationId, collectionId]);

  const handleLayerSelect = (
    selectedLayerId: string | undefined,
    e: React.MouseEvent,
  ) => {
    if (!selectedLayerId) {
      return;
    }
    e.stopPropagation();
    setLayerId(selectedLayerId);
  };

  useEffect(() => {
    if (!layerId && layers?.length) {
      setLayerId(layers[0].id);
    }
  }, [layerId, layers, setLayerId]);

  if (isLoading) {
    return (
      <LoadingMessage rootProps={{sx: {blockSize: 'auto', paddingBlock: 2}}} />
    );
  }

  if (error) {
    return (
      <ErrorMessage>
        <Typography variant="h6" color="inherit" gutterBottom>
          {error.message}
        </Typography>
      </ErrorMessage>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        m: `-${dimensions.leftSidebar.contentMargin}px`,
        height: `calc(100% + ${2 * dimensions.leftSidebar.contentMargin}px)`,
      }}
    >
      {layers?.map(layer => {
        return (
          <LayerAccordionItem
            key={layer.id}
            layer={layer}
            isSelected={layer.id === layerId}
            onClick={handleLayerSelect}
          />
        );
      })}
    </Box>
  );
};

export default LayerSelection;
